const values = {
  THREE_MONTHS: "THREE_MONTHS",
  SIX_MONTHS: "SIX_MONTHS",
  SIX_YEARS: "SIX_YEARS"
};
export default Object.freeze(values);
